exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main[data-v-40288f54]{width:800px;margin:0 auto}.main .title[data-v-40288f54]{font-size:16px;font-weight:500}\n", ""]);

// exports
